import { languages } from "locales/languages"
import config from "react-global-configuration"

import { Answer, Question } from "containers/Survey/types"
import { Call, CallRequest, ResponsePrice } from "types/payload"
import { Action, ActionWithoutPayload, Message } from "types/redux"

import {
  PAYMENT_REQUIRES_ACTION,
  PRICE_SUCCESS,
  RESET_PAYMENT_STORE,
  TLC_ERROR,
  TLC_REQUEST,
  TLC_SUCCESS,
  SETUP_PAYMENT_INTENT_REQUEST,
  GET_CALL_PRICE,
} from "./constants"
import { TELEEXPERTISE_CREATE_SUCCESS } from "containers/Teleexpertise/services/constants"
import { buildSurveySubmitPayload } from "./buildPayload"

const actions = {
  reset: (): ActionWithoutPayload => ({ type: RESET_PAYMENT_STORE }),
  submit: (answers?: Answer[], questions?: Question[]): Action<CallRequest> => {
    if (!answers)
      return { type: TLC_REQUEST, payload: { ...config.get("mock.get.call") } }

    return {
      type: TLC_REQUEST,
      payload: buildSurveySubmitPayload(answers, questions),
    }
  },

  error: (error: string): Action<Message> => ({
    type: TLC_ERROR,
    payload: { text: error || languages.cannotStartTLC, type: "error" },
  }),

  success: (payload: Call): Action<Call> => ({
    type: TLC_SUCCESS,
    payload,
  }),

  teleexpertiseSuccess: (): ActionWithoutPayload => ({
    type: TELEEXPERTISE_CREATE_SUCCESS,
  }),
  paymentRequiresAction: (
    payment_intent_client_secret: string,
  ): Action<string> => ({
    type: PAYMENT_REQUIRES_ACTION,
    payload: payment_intent_client_secret,
  }),
  priceSuccess: (payload: ResponsePrice): Action<ResponsePrice> => ({
    type: PRICE_SUCCESS,
    payload,
  }),

  createPaymentIntent: (): ActionWithoutPayload => ({
    type: SETUP_PAYMENT_INTENT_REQUEST,
  }),

  getCallPrice: (): ActionWithoutPayload => ({
    type: GET_CALL_PRICE,
  }),
}

export default actions
